import { create } from 'zustand';

const useUserStore = create((set) => ({
    // Tab Management
    openTabs: [],
    activeTab: 'listView', // 'listView' or 'userProfiles'
    activeTabId: null,

    addTab: (user, userType) => set((state) => {
        const id = user.userId || user.user?.userId;
        if (!id) return state; // Avoid adding a tab without a valid ID

        const existingTabIndex = state.openTabs.findIndex((t) => (t.userId || t.user?.userId) === id);
        if (existingTabIndex !== -1) {
            const newTabs = [...state.openTabs];
            newTabs[existingTabIndex] = { ...user, userType, userId: id };
            return { openTabs: newTabs, activeTab: 'userProfiles', activeTabId: id };
        }
        return {
            openTabs: [...state.openTabs, { ...user, userType, userId: id }],
            activeTab: 'userProfiles',
            activeTabId: id,
        };
    }),

    closeTab: (userId) => set((state) => {
        const newTabs = state.openTabs.filter((t) => (t.userId || t.user?.userId) !== userId);
        let nextActiveId = state.activeTabId;
        let nextTab = state.activeTab;

        if (state.activeTabId === userId) {
            if (newTabs.length > 0) {
                nextActiveId = newTabs[newTabs.length - 1].userId;
            } else {
                nextActiveId = null;
                nextTab = 'listView';
            }
        }

        return {
            openTabs: newTabs,
            activeTabId: nextActiveId,
            activeTab: nextTab,
        };
    }),

    setActiveTab: (tab) => set({ activeTab: tab }),
    setActiveTabId: (id) => set({ activeTabId: id, activeTab: 'userProfiles' }),

    // Search and Filters
    searchTerms: {}, // { STUDENT: '', FACULTY: '', etc }
    setSearchTerm: (userType, term) => set((state) => ({
        searchTerms: { ...state.searchTerms, [userType]: term }
    })),

    selectedGrades: {}, // { STUDENT: 'classId' }
    setSelectedGrade: (userType, classId) => set((state) => ({
        selectedGrades: { ...state.selectedGrades, [userType]: classId }
    })),

    // Pagination
    pagination: {}, // { STUDENT: { page: 1, pageSize: 10 } }
    setPagination: (userType, pageData) => set((state) => ({
        pagination: { ...state.pagination, [userType]: { ...(state.pagination[userType] || {}), ...pageData } }
    })),
    // Reset Store
    reset: () => set({
        openTabs: [],
        activeTab: 'listView',
        activeTabId: null,
        searchTerms: {},
        selectedGrades: {},
        pagination: {},
    }),
}));

export default useUserStore;
